var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../button';
import { services } from '@comall-backend-builder/core';
/**
 * 导出按钮
 */

var ExportButton = function (_super) {
  __extends(ExportButton, _super);

  function ExportButton(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    _this.download = _this.download.bind(_this);
    _this.state = {
      loading: false
    };
    return _this;
  }
  /**
   * 导出过程
   */


  ExportButton.prototype.download = function () {
    var _this = this;

    var _a = this.props,
        downloadUrl = _a.downloadUrl,
        params = _a.params,
        showErrorMessage = _a.showErrorMessage,
        onSuccess = _a.onSuccess,
        onError = _a.onError;

    var finish = function finish() {
      _this.setState({
        loading: false
      });
    };

    var error = function error(response) {
      finish();

      if (onError) {
        onError(response);
      }

      return response;
    };

    var success = function success(response) {
      finish();

      if (onSuccess) {
        onSuccess(response);
      }

      return response;
    }; // TODO here


    var result;
    this.setState({
      loading: true
    });

    if (downloadUrl) {
      console.warn('warning：ExportButton 组件中 downloadUrl 属性即将废弃，建议使用 source 属性替代');
      var requestParams_1 = {};

      var _b = services.interpolate(downloadUrl, this.props).split('?'),
          url = _b[0],
          query = _b[1];

      if (query) {
        query.split('&').forEach(function (expression) {
          var _a = expression.split('='),
              key = _a[0],
              value = _a[1];

          requestParams_1[key] = value;
        });
      }

      result = services.api.download(requestParams_1, {
        apiPath: url
      });
    } else {
      var _c = this.props.source,
          apiPath = _c.apiPath,
          apiRoot = _c.apiRoot,
          paramsFilter = _c.paramsFilter;
      result = services.api.download(params, {
        apiRoot: apiRoot,
        apiPath: apiPath,
        paramsFilter: paramsFilter
      });
    }

    result.then(success, error);

    if (showErrorMessage) {
      result.catch(services.errorHandle);
    }
  };
  /**
   * 处理按钮的点击事件
   */


  ExportButton.prototype.handleClick = function (event) {
    var _a = this.props,
        beforeExport = _a.beforeExport,
        onClick = _a.onClick;

    if (onClick) {
      onClick(event);
    }

    var download = this.download;

    if (this.state.loading) {
      return;
    }

    if (beforeExport) {
      beforeExport().then(download, function () {});
    } else {
      download();
    }
  };

  ExportButton.prototype.render = function () {
    var props = Object.assign({}, this.props, {
      loading: this.state.loading,
      onClick: this.handleClick
    });
    return React.createElement(Button, __assign({}, props));
  };

  ExportButton.propTypes = {
    downloadUrl: PropTypes.string,
    source: PropTypes.object,
    params: PropTypes.object,
    showErrorMessage: PropTypes.bool,
    onClick: PropTypes.func,
    beforeExport: PropTypes.func,
    onSuccess: PropTypes.func,
    onError: PropTypes.func
  };
  return ExportButton;
}(PureComponent);

export { ExportButton };